import React from "react"
import { Col, Container, Row, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

const Tile = (props) => {
  return (
    <Card className="mini-stat iconComponent text-white">
      <CardBody>
        <div className="mb-4">
          <h5 className="font-size-20 text-center mt-0 ">
            {props.name}
          </h5>
        </div>
        <div className="pt-2 text-center">
          <a href={props.link} className="btn btn-success mb-0 mt-1">
            Proceed
          </a>
        </div>
      </CardBody>
    </Card>
  )
}

export default Tile
